import { useMemo } from 'react';

interface PublicPreviewButtonProps {
  handle?: string | null;
  displayName?: string | null;
  email?: string | null;
  className?: string;
}

export default function PublicPreviewButton({ handle, displayName, email, className = '' }: PublicPreviewButtonProps) {
  const computedHandle = useMemo(() => handle?.trim().toLowerCase() || '', [handle]);
  const disabled = !computedHandle;

  const openPreview = () => {
    if (disabled) return;
    const path = `/s/${encodeURIComponent(computedHandle)}?preview=1`;
    if (typeof window !== 'undefined') {
      window.open(path, '_blank', 'noopener');
    }
  };

  return (
    <button
      type="button"
      onClick={openPreview}
      disabled={disabled}
      className={`rounded-xl border border-cocoa px-4 py-2 text-sm font-semibold text-cocoa shadow-sm transition hover:border-cocoa/70 disabled:cursor-not-allowed disabled:border-sand disabled:text-cocoa/50 ${className}`.trim()}
      title={disabled ? 'Add a display name or handle to preview your page.' : `Opens ${computedHandle} in a new tab`}
    >
      Preview public page
    </button>
  );
}
